import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import {Router} from "@angular/router";
// import { Store } from '@ngrx/store';
// import { UpdateUser } from '../modules/home/core/store/user/user.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, firstValueFrom, interval, lastValueFrom, Subscription, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { setUser } from '../store/user/user.actions';
import { setBrands } from '../store/brands/brands.actions';
import { environment } from '../../../environments/environment';
import { User } from '../interfaces/interfaces.interface';
import { Toast } from '../configs/toast';
import { BrandsService } from './brands.service';
import { StoreInterface } from '../store/store.interface';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
  urlFront = environment.url
  private refreshTokenInterval: Subscription | null = null;
  constructor(
      private rest:RestService,
      private router:Router,
      private store: Store<StoreInterface>,
      private brandsService: BrandsService
  ){

  }

  startTokenRefresh() {
    if (this.refreshTokenInterval) {
      this.refreshTokenInterval.unsubscribe();
    }

    // Intervalo de 3 horas (en milisegundos: 3 * 60 * 60 * 1000)
    this.refreshTokenInterval = interval(3 * 60 * 60 * 1000)
      .pipe(
        switchMap(() => this.checkSessionByToken()), // Llama a la función que refresca el token
        catchError((error) => {
          console.error('Error al refrescar el token:', error);
          this.logOut(); // Redirigir al inicio de sesión en caso de error
          throw error;
        })
      )
      .subscribe();
  }


  checkSessionByToken = ( ) => {
    return new Promise( async(resolve,reject) =>{
      try {
        const res = await firstValueFrom(this.rest.get(`/auth/refresh`))
        await this.setterSettings(res)
        
        resolve(true)
      } catch (e) {
        console.log(e)
        this.clear();
        this.redirectLogin();
        reject(false)
      }
    })
  }

  setterSettings = async ( res:{ access_token:string, user:User } ) => {
    if( res ) {
      const { user } = res
      localStorage.setItem('session', res.access_token)
      this.store.dispatch(setUser({ data:user }));
      
      // Si el usuario es super, cargar las marcas
      if (user.isSuper) {
        try {
          const brands = await this.brandsService.getBrands();
          this.store.dispatch(setBrands({ brands }));
        } catch (error) {
          console.error('Error al cargar las marcas:', error);
        }
      }
    }
  }

  logOut(){
    localStorage.clear()
    window.location.reload();
  }

  redirectLogin = () => {
      this.router.navigate(['/', 'auth', 'login']);
  }

  clear = () => {
    localStorage.removeItem('session')
  }
  
  login = async (data: any):Promise<boolean> => {
    try {
      const res = await firstValueFrom<any>(this.rest.post(`/auth/login`, data))
      console.log(res)
      if( res ) {
        const { user } = res
        const havePermission = user.permissions.find((p:string)=>p === 'pedido-amda-motos')
        if(!havePermission && !user.isSuper){
          this.clear()
          Toast.fire('Sin acceso al portal','','error')
          return false
        }
        this.setterSettings(res)
        this.router.navigate(['/home/lista']);
        return true
      }
    } catch (error) {
      if( error instanceof HttpErrorResponse ){
        console.log(error)
        const { status } = error
        if (status === 404 || status === 400) Toast.fire('Credenciales incorrectas','','error')
        if(status === 403) Toast.fire('Sin acceso al portal','','error')
        if (status === 0) Toast.fire('Sin conexión','Revise si esta conectado a internet','error')
      }
      return false
    }
    return true
  };

  register = (data: any) => new Promise((resolve, reject) => {
    this.rest.post(`/auth/register`,
      data)
      .subscribe(res => {
        // this.setterSettings(res)
        resolve(res);
      }, error => {
        reject(error);
      });
  });

  forgotPassword = async ( email:string ) => {
    console.log('Forgot not work?')
    await firstValueFrom(this.rest.post(`/auth/forgot`, { email }))
    .then((response: null | {message:string, intranetUser:boolean})=>{
      if(response){
        if(response.intranetUser){
            window.open(`http://162.255.87.55/corporativo/Principal/SendPassword.aspx?UserEmail=${email}`, '_blank');
        }else{
          Toast.fire('Correo enviado','','success')
        }
        this.redirectLogin()
      }
    }).catch((error:HttpErrorResponse)=>{
      if( error.status === 404 ) Toast.fire('El correo no existe','','error')
    })
  }

  resetPassword = async ( data: { id:string, password:string } )  => {
    await firstValueFrom (this.rest.post('/auth/reset', data)).then(()=>{
      Toast.fire('Contraseña cambiada','','success')
      this.redirectLogin()
    }).catch((error:HttpErrorResponse):any=>{
      console.log(error.status)
      console.log(error.error)
      if( error.status === 422 ) return Toast.fire('Token de verificación no valido','','error')
      Toast.fire('Error al enviar correo','','error')
    })
  }
}